import { render, staticRenderFns } from "./BaseUserAccountIcon.vue?vue&type=template&id=b9bd3642"
import script from "./BaseUserAccountIcon.vue?vue&type=script&lang=js"
export * from "./BaseUserAccountIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports